class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
      // document.querySelector('body').classList.remove('open-filter','open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    // const applyfilter = this.querySelector('.apply-filter');
    // if (applyfilter) applyfilter.addEventListener('click', this.debouncedOnSubmit.bind(this));
    const filterbtn = this.querySelector('.filter-button a');
    const filterclose = this.querySelector('.filter-close');
    const showbtn = this.querySelector('.show-button');
    if (filterbtn) filterbtn.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.toggle('open-filter');
      document.querySelector('body').classList.remove('open-sort','open-drawer','open-menu','open-search');
    });
    if (filterclose) filterclose.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-filter');
    });
    if (showbtn) showbtn.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-filter');
    });
    if (this.querySelector('.clear-filter')) {
      this.querySelector('.clear-filter').addEventListener('click', function (e) {
        e.preventDefault();
        const form = e.target.closest('form');
        form.reset();
        form.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(input => input.checked = false);
        FacetFiltersForm.renderPage('', e);
      });
    }
    if(document.querySelector('.sort-box')){
      this.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
  }
  static setListeners() {
      const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderActiveFilter(html);
        typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
        if(typeof quickAddButton == 'function'){
          quickAddButton();
        }
      });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    //FacetFiltersForm.renderActiveFilter(html);
    if(typeof quickAddButton == 'function'){
      quickAddButton();
    }
  }
  static renderProductGridContainer(html) {
    document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
    let count = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').getAttribute('data-count');
    document.querySelector('.filter-total-count').textContent = count;
  }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElements = parsedHTML.querySelectorAll('.filter-index');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.filter-index') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    let count = 0;
    facetDetailsElements.forEach((filter) => {
      if(filter.classList.contains('filter-list')){
        filter.querySelectorAll('ul li.active').forEach((index,list) => {
          count++;
        });
      }
    });
    if(count > 0){
      document.querySelectorAll('.filter-count').forEach((filterCount) => {
        filterCount.textContent = '('+count+')';
        filterCount.style.display = 'inline-block';
        filterCount.closest('.filter-button').classList.add('active');
      })
    }else{
      document.querySelectorAll('.filter-count').forEach((filterCount) => {
        filterCount.style.display = 'none';
        filterCount.closest('.filter-button').classList.remove('active');
      })
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
  // onSubmitHandler(event) {
  //   // event.preventDefault();
  //   // const formData = new FormData(event.target.closest('form'));
  //   // const searchParams = new URLSearchParams(formData).toString();
  //   // FacetFiltersForm.renderPage(searchParams, event);
  //   const filterCheck=(params)=>{
  //     return params.match(/filter/g).length
  //   }
  //   event.preventDefault();
  //   const formData = new FormData(event.target.closest("form"));
  //   let searchParams = new URLSearchParams(formData).toString();
  //   let result = filterCheck(searchParams);
  //   if(!(searchParams.includes("availability"))){
  //     searchParams = searchParams + "&filter.v.availability=1";
  //   }else if(result <= 3 && searchParams.includes("availability")){
  //     searchParams = searchParams.replace('&filter.v.availability=1', " ");
  //   }
  //   FacetFiltersForm.renderPage(searchParams, event); 
  // }
  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    let searchParams = new URLSearchParams(formData).toString();
    // Ensure price filter remains intact
    if (!searchParams.includes("filter.v.price")) {
      const lowerVal = document.querySelector("#lower").value;
      const upperVal = document.querySelector("#upper").value;
      searchParams += `&filter.v.price.gte=${lowerVal}&filter.v.price.lte=${upperVal}`;
    }
    FacetFiltersForm.renderPage(searchParams, event);
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
function rangePrice(){
  var lowerSlider = document.querySelector("#lower"),
      upperSlider = document.querySelector("#upper"),
      range = document.querySelector(".slider .progress");
  function applyFilter(){
    let lowerVal = parseInt(lowerSlider.value),
        upperVal = parseInt(upperSlider.value);
    const form = document.querySelector('facet-filters-form form');
    if (form) {
      const event = new Event('input', { bubbles: true });
      form.dispatchEvent(event);
    }
  }
  function updateSliderValues(){
    let lowerVal = parseInt(lowerSlider.value),
        upperVal = parseInt(upperSlider.value);
    document.querySelector(".prevtsetval").textContent = lowerVal;
    document.querySelector(".nextsetval").textContent = upperVal;

    const min = parseInt(lowerSlider.min);
    const max = parseInt(lowerSlider.max);
    const leftPercent = ((lowerVal - min) / (max - min)) * 100;
    const rightPercent = ((max - upperVal) / (max - min)) * 100;
    range.style.left = `${leftPercent}%`;
    range.style.right = `${rightPercent}%`;

    if(upperVal < lowerVal + 4){
      lowerSlider.value = upperVal - 4;
      if(lowerVal == lowerSlider.min){
        upperSlider.value = parseInt(lowerSlider.min) + 4;
      }
    }
    if(lowerVal > upperVal - 4){
      upperSlider.value = lowerVal + 4;
      if(upperVal == upperSlider.max){
        lowerSlider.value = parseInt(upperSlider.max) - 4;
      }
    }
    applyFilter();
  }
  lowerSlider.addEventListener('input', updateSliderValues);
  upperSlider.addEventListener('input', updateSliderValues);
  lowerSlider.parentElement.addEventListener('click', function (e) {
    if (e.target === lowerSlider || e.target === upperSlider) return; // Ignore clicks on the slider itself
    const rect = lowerSlider.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const maxValue = parseInt(lowerSlider.max);
    const minValue = parseInt(lowerSlider.min);
    const newValue = Math.round(((x / rect.width) * (maxValue - minValue)) + minValue);
    const lowerValue = parseInt(lowerSlider.value);
    const upperValue = parseInt(upperSlider.value);
    if(Math.abs(newValue - lowerValue) < Math.abs(newValue - upperValue)) {
      lowerSlider.value = newValue;
    }else{
      upperSlider.value = newValue;
    }
    updateSliderValues();
  });
}
if(document.querySelector(".rangecls")){
  rangePrice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect()